import { Heading, Icon, TextDownload } from '@dittolive/anvil'
import { DownloadSimpleIcon, SealIcon } from '@phosphor-icons/react'
import { toByteArray } from 'base64-js'
import dayjs, { Dayjs } from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import lowerFirst from 'lodash/lowerFirst'
import React from 'react'
import { useCallback } from 'react'

dayjs.extend(localizedFormat)

type KafkaCertCardProps = {
  cert: string
  title: string
  filename: string
  expiration?: Dayjs | null
}
export default function KafkaCertCard({
  cert,
  title,
  filename,
  expiration,
}: KafkaCertCardProps) {
  const renderExpiration = () => {
    if (!expiration) return null

    if (expiration.isBefore(dayjs())) {
      return 'Expired'
    } else {
      return `Expires ${expiration.format('LLL')}`
    }
  }

  const renderDownloadableLink = (
    hrefLink: string,
    fileName: string,
    label: string,
  ) => (
    <div className="flex flex-row items-center justify-end py-1">
      <TextDownload
        title={`Download ${lowerFirst(label)}`}
        href={hrefLink}
        fileName={fileName}
        className="text-foreground-subtle focus-visible:outline-focus-outline flex items-center justify-center text-sm outline-none focus-visible:outline-2"
      >
        <Icon svg={<DownloadSimpleIcon />} className="size-4" />
      </TextDownload>
    </div>
  )

  const base64BinaryToDownloadLink = useCallback((base64Value: string) => {
    const decodedBytes = toByteArray(base64Value)
    const blob = new Blob([decodedBytes as BlobPart], {
      type: 'application/x-pkcs12',
    })

    return URL.createObjectURL(blob)
  }, [])

  return (
    <div className="bg-background-surface-secondary flex w-1/2 flex-col gap-y-2 p-4 text-sm">
      <span className="bg-background-surface-secondary flex h-7 w-7 items-center justify-center rounded-full p-1">
        <Icon svg={<SealIcon />} className="size-7" />
      </span>
      <Heading level={4} className="text-base sm:text-base">
        {title}
      </Heading>
      <div className="flex items-center justify-between">
        <p className="text-foreground-subtle">{renderExpiration()}</p>

        {renderDownloadableLink(
          base64BinaryToDownloadLink(cert),
          filename,
          title,
        )}
      </div>
    </div>
  )
}
